import Phaser from 'phaser';
import { GameConfig } from './config';
import BootScene from './scenes/BootScene';
import GameScene from './scenes/GameScene';
import StartScene from './scenes/StartScene';
import GameOverScene from './scenes/GameOverScene';

class Game extends Phaser.Game {
  constructor() {
    super(GameConfig);
    
    // Register scenes
    this.scene.add('BootScene', BootScene);
    this.scene.add('GameScene', GameScene);
    this.scene.add('StartScene', StartScene);
    this.scene.add('GameOverScene', GameOverScene);
    
    // Start with the boot scene, which will then go to the start scene
    this.scene.start('BootScene');
    
    // Notify when the game is fully loaded
    this.events.once('ready', () => {
      // Dispatch custom event when game is loaded
      window.dispatchEvent(new Event('game-loaded'));
      console.log('Game fully loaded and ready');
    });
  }
}

// Wait for the DOM to be ready
window.addEventListener('load', () => {
  // Create and start the game
  const game = new Game();
  
  // Handle window resize
  window.addEventListener('resize', () => {
    game.scale.refresh();
  });
});

// Handle browser visibility changes
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    // Game is hidden (tab inactive, etc.)
    // Pause the game if needed
  } else {
    // Game is visible again
    // Resume the game if needed
  }
}); 